import React from 'react'
import { Grid, Typography } from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'
import { useIntl } from 'src/common/razzle-platform-translate'
import {DefaultButton} from 'src/common/razzle-platform-user/Authentication/components/defaultFields'
import {useAuth} from 'src/common/razzle-platform-user/Authentication/hooks'
import {BASE_URL} from 'src/common/razzle-platform-user/configs'


const useStyles = makeStyles(theme => ({
    container: {
        paddingBottom: 30,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 40
    },
    descriptionContainer: {
        paddingBottom: 0
    },
    description: {
        marginTop: 0
    }
}))


const Authorization = (props) => {

    const classes = useStyles(props)
    const { actions } = useAuth()
    const { formatMessage } = useIntl()

    const Button = props.button || DefaultButton
    return (
        <div className={classes.container}>
			<Grid container={true} spacing={4}>
                <Grid container={true} item={true} xs={12} direction="row" justify="center" className={classes.descriptionContainer}>
                    <Typography variant={"body1"} className={classes.description} >
                        {actions.authorization.description
                            ? actions.authorization.description 
                            : formatMessage({ id: "Vous n'avez pas les droit d'access", defaultMessage: "Vous n'avez pas les droit d'access" })
                        }
                    </Typography>
                </Grid>
				<Grid container={true} item={true} xs={12} direction="row" justify="center" style={{marginTop: 5}}>
                    <Grid item={true} xs={8}>
                        <Button onClick={() => {window.location.href = actions.authorization.redirectTo ? actions.authorization.redirectTo: `${BASE_URL}app/dashboard` }}>
                            {actions.authorization.buttonTitle 
                                ? actions.authorization.buttonTitle 
                                : formatMessage({ id: 'Abonnez-vous maintenant', defaultMessage: 'Abonnez-vous maintenant'})
                            }
                        </Button>
                    </Grid>
                </Grid>

			</Grid>
        </div>
    )
}

export default Authorization
